import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { isDevMode } from '@angular/core';

export class BaseService<T> {
  private content: T = undefined;

  public constructor(private apiService: ApiService) {}

  public Get(api: string, args: Object, json?: boolean, version?: string): Observable<T> {
    try {
      return this.apiService
        .CallGet(api, args, json, version)
        .pipe(
          map(this.Checking.bind(this)),
          map(this.getApiDebugData.bind(this)),
          catchError(this.HandleError.bind(this))
        ) as Observable<T>;
    } catch (err) {
      throw err;
    }
  }

  public Post(api: string, args: Object, data: FormData | string, version?: string): Observable<T> {
    try {
      return this.apiService
        .CallPost(api, args, data, version)
        .pipe(
          map(this.Checking.bind(this)),
          map(this.HandleResponse.bind(this)),
          catchError(this.HandleError.bind(this))
        ) as Observable<T>;
    } catch (err) {
      throw err;
    }
  }

  public Checking(response: JSON): JSON {
    if (!response) return;

    if (response['result'] == 400) {
      localStorage.removeItem('account');
      throw new Error('NOT_CONNECTED');
    }
    if (response['result'] >= 450 && response['result'] <= 460) {
      //IDP RENAULT ERROR
      throw new Error(`code ${response['result']}`);
    }
    return response;
  }

  private HandleError(error: any) {
    if (error.status === 0 || error.status === 504 || error.status === 500) {
      error.statusText = 'connection';
      return observableThrowError(error);
    }

    if (error.status === 400) {
      error.statusText = 'wrongId';
      // TODO Rajouter logout si erreur 400
      return observableThrowError(error);
    }
    console.log('ERROR STATUS: ', error.status);
    error.statusText = 'defaultError';
    return observableThrowError(error);
  }

  public getApiDebugData(response: JSON) {
    if (!response) return;

    if (isDevMode()) {
      if (response['__elapsedSQL__'] > 300) {
        console.debug(response);
      }
      this.apiService.sqlRequests.push(response['__elapsedSQL__']);
      // this.apiService.apiRequests.push(response['__elapsed__']);
    }
    this.apiService.serverTime = response['time']; // Get server time to sync with app time
    this.apiService.deltaServer = Math.trunc(new Date().getTime() / 1000) - this.apiService.serverTime; // Get the diff between the server and user's pc (seconds)
    return this.HandleResponse(response);
  }

  public HandleResponse(response: JSON) {}
}
